import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./ImagesLightbox.scss";

const ImagesLightbox = ({
  hotelImages = [],
  selectedItem = 0,
  centerMode,
  centerSlidePercentage = 80,
}) => {
  const slides = Array.isArray(hotelImages) ? hotelImages : [];
  if (slides.length === 0) {
    return null;
  }
  const useCenterMode =
    typeof centerMode === "boolean" ? centerMode : slides.length > 1;
  const startIndex = Math.min(
    Math.max(Number(selectedItem) || 0, 0),
    slides.length - 1,
  );

  return (
    <div className="carousel-wrapper">
      <Carousel
        showStatus={slides.length > 1}
        showIndicators={false}
        showThumbs={false}
        dynamicHeight={false}
        emulateTouch
        useKeyboardArrows
        infiniteLoop={slides.length > 1}
        showArrows={slides.length > 1}
        centerMode={useCenterMode}
        centerSlidePercentage={useCenterMode ? centerSlidePercentage : 100}
        selectedItem={startIndex}
      >
        {slides.map((hotelImage, i) => (
          <div key={`hotel-lightbox-${i}`}>
            <img
              src={hotelImage}
              alt={`hotel-${i + 1}`}
              className="carousel-images"
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default ImagesLightbox;
